import { lt, useFeatureFlag } from '@mews/framework';
import { Divider, DropDownButton, DropdownItem, IconName } from '@optimus-web/core';
import { EnterpriseLink } from '@mews-commander/ui';
import { FeatureFlag } from '@mews-commander/enums';
import { copyInputToClipboard } from '@mews-commander/utils';
import { useEditProductCategoryDialogForm } from '../../forms/useEditProductCategoryDialogForm';
import { useDeleteProductCategoryDialog } from '../../hooks/useDeleteProductCategoryDialog';

interface Props {
    productCategoryId: string;
}
export const CategoryActionButton = ({ productCategoryId }: Props) => {
    const [renderEditProductCategoryDialog, toggleEditProductCategoryDialog] = useEditProductCategoryDialogForm({
        productCategoryId,
    });
    const { confirmationDialog, openConfirmationDialog } = useDeleteProductCategoryDialog({ productCategoryId });
    const isNewProductCategoryFormEnabled = useFeatureFlag(FeatureFlag.fePoductCategoryFormEnabled);
    return (
        <>
            <DropDownButton icon={IconName.More} size="small">
                {isNewProductCategoryFormEnabled ? (
                    <DropdownItem
                        label={lt('ProductTableEditProductCategoryButtonLabel')}
                        onClick={toggleEditProductCategoryDialog}
                    />
                ) : (
                    <DropdownItem
                        label={
                            <EnterpriseLink
                                params={{ id: productCategoryId }}
                                to="ProductCategory/Detail/$id"
                                underline={false}
                                variant="basic"
                            >
                                {lt('ProductTableEditProductCategoryButtonLabel')}
                            </EnterpriseLink>
                        }
                    />
                )}
                <DropdownItem
                    label={lt('CopyCategoryId')}
                    onClick={() => {
                        copyInputToClipboard(productCategoryId);
                    }}
                />
                <Divider />
                <DropdownItem label={lt('Delete')} variant="danger" onClick={openConfirmationDialog} />
            </DropDownButton>
            {confirmationDialog}
            {renderEditProductCategoryDialog()}
        </>
    );
};
